module.exports = __webpack_public_path__ + "media/images/default_thumbnail_quiz-d45da5e8f546c46a36b62603d787b619.png";